<template>
    <div v-if="show">
        <div class="overlay" @click="onCloseCallback"></div>
        <div class="modal terms-and-conditions">
            <div class="modal-content">
                <div class="modal-title">
                    <span class="text">Terms & Conditions</span>
                </div>
				<p>
					Welcome to <strong>War Chest Online</strong>,
					 an unofficial digital adaptation of <em>War Chest</em>,
					 a strategy board game by Alderac Entertainment Group (AEG).
					 By using this website, you agree to the following rules:
				</p>
				<ol>
					<li>
					<strong>Be respectful:</strong> The use of abusive, racist, or toxic language —
					 including in chats, direct messages, usernames, and room names, etc. —
					  is strictly prohibited.
					</li>
					<li>
					<strong>Fair play:</strong> Cheating is strictly prohibited.
					 This includes creating secondary accounts to play against yourself (“win trading”)
					  or changing settings right before a match starts (“fluxxing”).
					</li>
					<li>
					<strong>Good sportsmanship:</strong> Win with humility, lose with grace.
					 We’re here to have fun and enjoy the game together.
					</li>
					<li>
					<strong>Bugs:</strong> If you encounter any bugs, please report them
					 either via our  <a class="discord-invite-link"
					  href="https://discord.gg/AmeKEDc" target="_blank">
					  Discord</a> server or by sending a direct message to
					 SpruceGoose on the site. Exploiting bugs to gain an advantage is prohibited.
					</li>
					<li>
						<strong>Communication:</strong> We may occasionally email you about
						new features, invite you for exclusive playtesting of new expansions,
						or inform you of creative projects such as crowdfunding campaigns by
						the creator of this site. You will have the option to opt out
						of such emails. War Chest Online will <u>never</u> share your email or
						private information.
					</li>
				</ol>
				<p>
					Thank you for being part of our community and
					 helping make War Chest Online a safe and
					 welcoming space for everyone!
				</p>
			</div>
            <span class="close-modal-btn" @click="onCloseCallback">
                <fa-icon class="close-modal-icon" icon="times" />
            </span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'TermsAndConditionsModal',
    props: ['show', 'onCloseCallback'],
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

    .modal {

        &.terms-and-conditions {
            font-size: .9em;
            min-width: 350px;
            height: 80%;

            .modal-content {
                height: 100%;
                overflow: auto;
            }

            .modal-title {
                text-align: center;
            }

            ol {
                margin-left: 30px;
                margin-top: 15px;
                margin-bottom: 15px;
                list-style-type: disc;
				text-align: left;

                li {
                    margin-bottom: 10px;

                    &:last-of-type {
                        margin-bottom: 0;
                    }
                }
            }

			.discord-invite-link {
				color: $discord;
			}

			.close-modal-btn {
                cursor: pointer;
                position: absolute;
                right: 20px;
                top: 20px;
            }
        }
    }
</style>
